<template>
    <div class="horizontal-divider"></div>
</template>

<style scoped>
@reference '../../../css/tailwind.css';

@layer components {
    .horizontal-divider {
        @apply w-full border-t border-[#E8E8E8] my-4;
    }
}
</style>
